// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"474eda65","453":"6c7a1784","483":"373609b5","684":"18aa5422","839":"2a9a5da0"}[chunkId] + ".chunk.js";
};